import _ from 'lodash';
import { isMobile } from './isMobile';

const mobile = isMobile();

var Flux = function(opts)
{
    this.options = _.extend({
        width: window.innerWidth,
        height: window.innerHeight,
        meter: 100,
        wind: 0,
        windFactor: 40,
        gravity: 10,
        gravityFactor: 40,
        timeStep: 1.0 / (mobile ? 23.0 : 30.0),
        velocityIterations: 8,
        positionIterations: 3,
        particlesRadius: 0.05,
        particlesDampingStrength: 1.5,
        particlesDensity: 10,
        particleGroupFlags: [], // b2_solidParticleGroup
        particleFlags: [b2_colorMixingParticle, b2_viscousParticle], // b2_viscousParticle || b2_waterParticle || b2_tensileParticle || b2_springParticle || b2_colorMixingParticle
        particleGroupStrength: 1,
        wallsDensity: 2,
        wallsFriction: 0,
        wallsRestitution: 1,
        pipeSize: 6,
        offsetX: 0,
        offsetY: 0,
        mouse: !mobile,
        mouseSize: 20,
        intensity: 0,
        walls: [],
        pipes: [],
        blobs: [],
        movingWalls: []
    }, opts);

    this.width = this.options.width;
    this.height = this.options.height;

    this.walls = this.options.walls;
    this.pipesWalls = this.options.pipesWalls;
    this.pipes = this.options.pipes;
    this.blobs = this.options.blobs;
    this.movingWalls = this.options.movingWalls;
    this.intensity = this.options.intensity;
    this.movingWallsAnimations = [];

    this.time = 0;
    this.currentTime = null;
    this.world = window.world = new b2World(new b2Vec2(this.options.wind, this.options.gravity));

    this.particleGroups = [];

    this.build();
    this.updateIntensity(this.intensity);
};

Flux.prototype.build = function()
{
    var bd = new b2BodyDef();
    var groundBody = this.groundBody = world.CreateBody(bd);

    var bdDef = new b2BodyDef();
    this.body = world.CreateBody(bdDef);

    this.buildWalls();
    this.buildPipes();
    this.buildParticles();
    this.buildMovingWalls();

    if (this.options.mouse)
    {
        this.createMouseJoint();
    }
};

Flux.prototype.applyForce = function(x, y)
{
    for (var i = 0, il = this.particleGroups.length; i < il; i++)
    {
        this.particleGroups[i].ApplyLinearImpulse(new b2Vec2(x, y));
    }
};

Flux.prototype.createMouseJoint = function()
{
    var mouseBodyDef = new b2BodyDef;
    this.mouseBody = this.world.CreateBody(mouseBodyDef);

    var mouseSize = this.options.mouseSize;

    this.createWall(0, 0, mouseSize, mouseSize, {
        body: this.mouseBody
    });

    this.createWall(0, 0, mouseSize, mouseSize, {
        angle: 45,
        body: this.mouseBody
    });
    this.hideMouseBody();
};

Flux.prototype.hideMouseBody = function()
{
    var mouseSize = this.options.mouseSize;
    var meter = this.options.meter;
    var realX = this.fromPercentWidth((0.5 * 100)+'') - (mouseSize / 2);
    var realY = this.fromPercentHeight((2 * 100)+'') - (mouseSize / 2);
    this.mouseBody.SetTransform(new b2Vec2(realX/this.options.meter,realY/this.options.meter), this.mouseBody.GetAngle());
};

Flux.prototype.updateMouseDownPosition = function(position, offsetY)
{
    if (!this.options.mouse)
    {
        return;
    }

    if (position === null)
    {
        this.hideMouseBody();
    } else {
        var meter = this.options.meter;
        var mouseSize = this.options.mouseSize;
        var realX = this.fromPercentWidth((position.x * 100)+'') - mouseSize;
        var realY = this.fromPercentHeight((position.y * 100)+'') - mouseSize - offsetY;
        this.mouseBody.SetTransform(new b2Vec2(realX/this.options.meter,realY/this.options.meter), this.mouseBody.GetAngle());
    }
};

Flux.prototype.updateIntensity = function(intensity)
{
    this.intensity = intensity;
    this.world.SetGravity(new b2Vec2(this.options.wind+this.options.windFactor*intensity,this.options.gravity+this.options.gravityFactor*intensity));
};

Flux.prototype.buildWalls = function()
{
    for(var i = 0, wl = this.walls.length; i < wl; i++)
    {
        var wall = this.walls[i];
        var wallX = _.isString(wall.x) ? this.fromPercentWidth(wall.x):(
            _.isFunction(wall.x) ? wall.x.call(this):wall.x
        );
        var wallY = _.isString(wall.y) ? this.fromPercentHeight(wall.y):(
            _.isFunction(wall.y) ? wall.y.call(this):wall.y
        );
        var wallWidth = _.isString(wall.width) ? this.fromPercentWidth(wall.width):(
            _.isFunction(wall.width) ? wall.width.call(this):wall.width
        );
        var wallHeight = _.isString(wall.height) ? this.fromPercentHeight(wall.height):(
            _.isFunction(wall.height) ? wall.height.call(this):wall.height
        );
        var opts = _.omit(wall, ['width', 'height', 'x', 'y']);
        this.createWall(wallX, wallY, wallWidth, wallHeight, opts);
    }
};

Flux.prototype.buildPipes = function()
{
    for(var i = 0, wl = this.pipes.length; i < wl; i++)
    {
        var pipe = this.pipes[i];
        var pipeX = _.isString(pipe.x) ? this.fromPercentWidth(pipe.x):(
            _.isFunction(pipe.x) ? pipe.x.call(this):pipe.x
        );
        var pipeY = _.isString(pipe.y) ? this.fromPercentHeight(pipe.y):(
            _.isFunction(pipe.y) ? pipe.y.call(this):pipe.y
        );
        var pipeWidth = _.isString(pipe.width) ? this.fromPercentWidth(pipe.width):(
            _.isFunction(pipe.width) ? pipe.width.call(this):pipe.width
        );
        var pipeHeight = _.isString(pipe.height) ? this.fromPercentHeight(pipe.height):(
            _.isFunction(pipe.height) ? pipe.height.call(this):pipe.height
        );
        var opts = _.omit(pipe, ['width', 'height', 'x', 'y']);
        this.createPipe(pipeX, pipeY, pipeWidth, pipeHeight, opts);
    }

};

Flux.prototype.buildParticles = function()
{
    //Particles
    var psd = new b2ParticleSystemDef();
    psd.radius = this.options.particlesRadius;
    psd.dampingStrength = this.options.particlesDampingStrength;
    psd.density = this.options.particlesDensity;
    this.particleSystem = world.CreateParticleSystem(psd);

    for (var bi = 0, bl = this.blobs.length; bi < bl; bi++)
    {
        var blob = this.blobs[bi];
        var blobX = _.isString(blob.x) ? this.fromPercentWidth(blob.x):(
            _.isFunction(blob.x) ? blob.x.call(this):blob.x
        );
        var blobY = _.isString(blob.y) ? this.fromPercentHeight(blob.y):(
            _.isFunction(blob.y) ? blob.y.call(this):blob.y
        );
        var blobWidth = _.isString(blob.width) ? this.fromPercentWidth(blob.width):(
            _.isFunction(blob.width) ? blob.width.call(this):blob.width
        );
        var blobHeight = _.isString(blob.height) ? this.fromPercentHeight(blob.height):(
            _.isFunction(blob.height) ? blob.height.call(this):blob.height
        );
        var opts = _.omit(blob, ['width', 'height', 'x', 'y', 'color']);

        blob.color = _.isArray(blob.color) ? blob.color:[255,0,0,255];
        opts.color = new b2ParticleColor(blob.color[0], blob.color[1], blob.color[2], blob.color[3]);
        this.createBlob(blobX, blobY, blobWidth, blobHeight, opts);
    }
};

Flux.prototype.buildMovingWalls = function()
{
    this.movingWallsAnimations = [];

    for (var i = 0, il = this.movingWalls.length; i < il; ++i)
    {
        // create wall
        var wall = this.movingWalls[i];
        var wallX = _.isString(wall.x) ? this.fromPercentWidth(wall.x):(
            _.isFunction(wall.x) ? wall.x.call(this):wall.x
        );
        var wallY = _.isString(wall.y) ? this.fromPercentHeight(wall.y):(
            _.isFunction(wall.y) ? wall.y.call(this):wall.y
        );
        var wallWidth = _.isString(wall.width) ? this.fromPercentWidth(wall.width):(
            _.isFunction(wall.width) ? wall.width.call(this):wall.width
        );
        var wallHeight = _.isString(wall.height) ? this.fromPercentHeight(wall.height):(
            _.isFunction(wall.height) ? wall.height.call(this):wall.height
        );
        var opts = _.omit(wall, ['width', 'height', 'x', 'y', 'tween']);

        var bdDef = new b2BodyDef();
        var body = this.world.CreateBody(bdDef);
        opts.body = body;
        this.createWall(wallX, wallY, wallWidth, wallHeight, opts);

        var tweenOpts = wall.tween;
        var invisibleWhenPaused = false;

        if (typeof tweenOpts !== 'undefined')
        {
            var toX = _.isString(tweenOpts.x) ? this.fromPercentWidth(tweenOpts.x):(
                _.isFunction(tweenOpts.x) ? tweenOpts.x.call(this):tweenOpts.x
            );
            var toY = _.isString(tweenOpts.y) ? this.fromPercentHeight(tweenOpts.y):(
                _.isFunction(tweenOpts.y) ? tweenOpts.y.call(this):tweenOpts.y
            );

            var paused = typeof tweenOpts.paused !== 'undefined' ? tweenOpts.paused:false;
            var loop = typeof tweenOpts.loop !== 'undefined' ? tweenOpts.loop:true;
            invisibleWhenPaused = typeof tweenOpts.invisibleWhenPaused !== 'undefined' ? tweenOpts.invisibleWhenPaused : false;

            var deltaX = (toX - wallX) / this.options.meter || 0;
            var deltaY = (toY - wallY) / this.options.meter || 0;

            // create tween
            var tweenParams = _.extend({
                duration: 1,
                ease: Linear.easeNone,
                delay: 0,
                percent: 1,
                onUpdateParams: ['{self}', body, deltaX, deltaY],
                onUpdate: _.bind(function(tween, body, deltaX, deltaY){
                    var percent = tween.target.percent;
                    body.SetTransform(new b2Vec2(deltaX*percent,deltaY*percent),body.GetAngle());
                },this),
                onCompleteParams: [invisibleWhenPaused, body],
                onComplete: function(invisibleWhenPaused, body)
                {
                    if (invisibleWhenPaused)
                    {
                        setTimeout(_.bind(function(){
                            body.SetTransform(new b2Vec2(0, 999999), body.GetAngle());
                        }, this), 1)
                    }
                }
            },tweenOpts);
            var duration = tweenParams.duration;
            tweenParams = _.omit(tweenParams, ['duration', 'x', 'y', 'name', 'paused', 'invisibleWhenPaused', 'loop']);

            // add to timeline
            var timeline = new TimelineMax();
            timeline.to({percent:0}, duration, tweenParams);

            if (paused)
            {
                timeline.pause();
                if (loop)
                {
                    timeline.eventCallback('onComplete', function(){
                        this.progress(0);
                        this.pause();
                    });
                }
            }

            if (invisibleWhenPaused)
            {
                body.SetTransform(new b2Vec2(0, 999999), body.GetAngle());
            }

            this.movingWallsAnimations.push({
                name: tweenOpts.name,
                timeline: timeline
            });
        }
    }
};

Flux.prototype.getMovingWalls = function()
{
    return this.movingWallsAnimations;
};

Flux.prototype.fromPercentWidth = function(percent)
{
    var number = parseFloat(percent.replace(/[^0-9\-\.]+/gi, ''))/100;
    return number * this.width;
};

Flux.prototype.fromPercentHeight = function(percent)
{
    var number = parseFloat(percent.replace(/[^0-9\-\.]+/gi, ''))/100;
    return number * this.height;
};

Flux.prototype.createBlob = function(x, y, width, height, opts)
{
    opts = _.extend({
        offsetX: 0,
        offsetY: 0,
        offsetWidth: 0,
        offsetHeight: 0,
        color: null
    }, opts);

    var box = new b2PolygonShape();
    var realWidth = (width + opts.offsetWidth)/2;
    var realHeight = (height + opts.offsetHeight)/2;
    var realX = x + realWidth + opts.offsetX + this.options.offsetX;
    var realY = y + realHeight + opts.offsetY + this.options.offsetY;
    box.SetAsBoxXYCenterAngle(realWidth/this.options.meter, realHeight/this.options.meter,new b2Vec2(realX/this.options.meter,realY/this.options.meter), 0);

    var particleGroupDef = new b2ParticleGroupDef();
    particleGroupDef.groupFlags = this.options.particleGroupFlags;
    particleGroupDef.flags = this.options.particleFlags;
    particleGroupDef.shape = box;
    particleGroupDef.strength = this.options.particleGroupStrength;
    if(opts.color)
    {
        particleGroupDef.color = opts.color;
    }
    var particleGroup = this.particleSystem.CreateParticleGroup(particleGroupDef);
    this.particleGroups.push(particleGroup);
};

Flux.prototype.createPipe = function(x, y, width, height, opts)
{
    opts = _.extend({
        size: this.options.pipeSize
    }, opts);
    var pipeSize = opts.size;

    // top left
    var left = this.createWall(x, y, pipeSize, height, opts);
    var right = this.createWall(x + width - pipeSize, y, pipeSize, height, opts);

    this.body.CreateFixtureFromShape(left, 5);
    this.body.CreateFixtureFromShape(right, 5);

    var shapes = [left, right];
    return shapes;
};

Flux.prototype.createWall = function(x, y, width, height, opts)
{
    opts = _.extend({
        body: this.body,
        angle: 0,
        offsetX: 0,
        offsetY: 0,
        offsetWidth: 0,
        offsetHeight: 0,
        density: this.options.wallsDensity,
        friction: this.options.wallsFriction,
        restitution: this.options.wallsRestitution
    }, opts);

    var angle = opts.angle * Math.PI / 180;
    var realWidth = (width + opts.offsetWidth)/2;
    var realHeight = (height + opts.offsetHeight)/2;
    var realX = x + realWidth + opts.offsetX + this.options.offsetX;
    var realY = y + realHeight + opts.offsetY + this.options.offsetY;
    var wall = new b2PolygonShape();
    wall.SetAsBoxXYCenterAngle(realWidth/this.options.meter, realHeight/this.options.meter,new b2Vec2(realX/this.options.meter,realY/this.options.meter), angle);

    var fixtureDef = new b2FixtureDef();
    fixtureDef.shape = wall;
    fixtureDef.density = opts.density;
    fixtureDef.friction = opts.friction;
    fixtureDef.restitution = opts.restitution;

    opts.body.CreateFixtureFromDef(fixtureDef);

    return wall;
};

Flux.prototype.getWorld = function()
{
    return this.world;
};

Flux.prototype.getParticleSystems = function()
{
    return this.world.particleSystems;
};

Flux.prototype.getBodies = function()
{
    return this.world.bodies;
};

Flux.prototype.tick = function(initial = false)
{
    const currentTime = new Date().getTime();
    const elapsed = this.currentTime !== null && initial !== true ? (currentTime - this.currentTime) / 1000 : this.options.timeStep;

    this.world.Step(elapsed, this.options.velocityIterations, this.options.positionIterations);
    this.time += elapsed;
    this.currentTime = currentTime;
};

Flux.prototype.resize = function(width, height)
{
    this.width = width;
    this.height = height;

    this.reset();
};

Flux.prototype.reset = function()
{
    this.destroy();
    this.build();
};

Flux.prototype.destroy = function()
{
    while(this.movingWallsAnimations && this.movingWallsAnimations.length)
    {
        this.movingWallsAnimations[this.movingWallsAnimations.length-1].timeline.kill();
        this.movingWallsAnimations.pop();
    }
    this.movingWallsAnimations = null;

    if(this.world !== null)
    {
        while(this.world.joints.length > 0)
        {
            this.world.DestroyJoint(this.world.joints[0]);
        }

        while(this.world.bodies.length > 0)
        {
            this.world.DestroyBody(this.world.bodies[0]);
        }

        while(this.world.particleSystems.length > 0)
        {
            this.world.DestroyParticleSystem(this.world.particleSystems[0]);
        }
    }
};


module.exports = Flux;



// WEBPACK FOOTER //
// ./js/lib/flux.js